import { usePopoverPortalContext } from "@circle-react-shared/uikit/PopoverPortal";
import { isIntendedOnNewTab } from "@circle-react/helpers/browserHelpers";
import type {
  BaseBookmarkRecord,
  BookmarkType,
} from "@circle-react/types/Bookmarks";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import { Link } from "@tanstack/react-router";
import { noop } from "lodash";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
interface BookmarkItemWrapperProps {
  bookmark: BaseBookmarkRecord;
  bookmarkType: BookmarkType;
  children: ReactNode;
}

export const BookmarkItemWrapper = ({
  children,
  bookmark,
  bookmarkType,
}: BookmarkItemWrapperProps) => {
  const { onClose = noop }: { onClose?: () => void } =
    usePopoverPortalContext() ?? {};
  if (!bookmark.bookmark_record) {
    return (
      <div className="flex w-full items-center gap-3 rounded-md bg-secondary px-4 py-3">
        <Icon name="trash-can" size="sm" />
        <Typography variant="label-sm">
          {t("bookmarks.errors.content_removed", {
            type: t(["bookmarks.singular", bookmarkType]),
          })}
        </Typography>
      </div>
    );
  }

  return (
    <Link
      to={bookmark.bookmark_record.show_url}
      className="w-full"
      onClick={event => {
        if (isIntendedOnNewTab(event)) {
          return;
        }
        onClose();
      }}
    >
      {children}
    </Link>
  );
};
